import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      toast.error('Please enter your email address');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim() })
      });
      if (!res.ok) throw new Error('Request failed');
      setSubmitted(true);
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex">
      <div
        className="flex-1 bg-cover bg-center"
        style={{ backgroundImage: 'url("https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&q=80")' }}
      />
      <div className="w-full max-w-md bg-white flex flex-col justify-center px-12">
        <div className="mb-8">
          <div className="flex items-center gap-2 mb-12">
            <span className="text-gray-600 text-4xl font-light">resto</span>
            <div className="w-16 h-16 rounded-full bg-[#FFA94D] flex items-center justify-center">
              <span className="text-white text-xl font-semibold">mp</span>
            </div>
          </div>
        </div>

        {submitted ? (
          <div className="space-y-6">
            <h2 className="text-2xl text-gray-700 font-light">Check Your Email</h2>
            <p className="text-gray-500 text-sm">
              If an account with <strong>{email}</strong> exists, we've sent a password reset link. Please check your inbox.
            </p>
            <Link to="/" className="inline-block text-sm text-blue-600 hover:underline" data-testid="back-to-login">
              Back to login
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-6">
            <h2 className="text-2xl text-gray-700 font-light">Forgot Password</h2>
            <p className="text-gray-500 text-sm">Enter your email address and we'll send you a link to reset your password.</p>
            <div>
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-[#FFA94D] focus:border-transparent text-gray-700"
                required
                data-testid="forgot-email-input"
              />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#FFA94D] hover:bg-[#F08A2A] text-white py-3 rounded font-medium transition-colors disabled:opacity-50"
              data-testid="forgot-submit-btn"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <Link to="/" className="inline-block text-sm text-blue-600 hover:underline" data-testid="back-to-login">
              Back to login
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
